import React, { createContext, useContext, useState } from "react";

type PageTitleState = {
	/** Título base de la página activa (cuerpo, sin el sufijo de marca). */
	title: string;
	/** Nombre legible de la entidad concreta (rootName de la ladle/tundish). */
	entityName?: string;
};

type Ctx = PageTitleState & {
	setPageTitle: (s: PageTitleState) => void;
};

const PageTitleContext = createContext<Ctx>({
	title: "",
	setPageTitle: () => {},
});

/**
 * Guarda el título de la página activa para que componentes profundos (p.ej. el
 * Modal) puedan componer su propio título "<algo> · <página donde se abrió>".
 * Lo alimenta `<PageTitle>`.
 */
export const PageTitleProvider = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	const [state, setState] = useState<PageTitleState>({ title: "" });
	return (
		<PageTitleContext.Provider value={{ ...state, setPageTitle: setState }}>
			{children}
		</PageTitleContext.Provider>
	);
};

export const usePageTitleContext = () => useContext(PageTitleContext);
